import React from 'react';
import { VStack, Flex, Box, Container } from '@chakra-ui/react';
import { Button, HeadingText, BodyText, Link } from '@spotoninc/nexus-react';
import { EmailIcon, CheckCircleIcon } from '@chakra-ui/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { TopBar } from '@spotoninc/nexus-react';
import { LoyaltyBrandIcon } from '@spotoninc/nexus-web-assets';

const RegistrationConfirmation = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userEmail =
    searchParams.get('email') || 'your registered email address';

  const customAppName = (
    <Flex
      align="center"
      gap="8px"
      pl="0"
      style={{
        marginLeft: 0,
        paddingLeft: 0,
      }}
      className="app-name-container"
    >
      <LoyaltyBrandIcon
        size="2rem"
        color="#FFFFFF"
        className="app-logo"
        style={{ marginRight: '18px' }}
      />
      <HeadingText className="app-name">Profit Assist</HeadingText>
    </Flex>
  );

  return (
    <Box minH="100vh" bg="white">
      {/* Top Bar */}
      <TopBar
        applicationName={customAppName}
        currentPageName="Profit Assist"
        className="registration-topbar"
      />

      <Container maxW="container.md" py={16}>
        <VStack spacing={8} align="center" justify="center">
          <Flex
            width="80px"
            height="80px"
            borderRadius="full"
            bg="green.100"
            align="center"
            justify="center"
            mb={4}
          >
            <CheckCircleIcon w={10} h={10} color="green.500" />
          </Flex>

          <HeadingText
            variant="heading2"
            color="neutral.900"
            textAlign="center"
          >
            Registration Successful!
          </HeadingText>

          <BodyText
            size="medium"
            textAlign="center"
            maxW="600px"
            style={{ textAlign: 'center' }}
          >
            Thank you for registering with Profit Assist. We've sent a
            confirmation email to <strong>{userEmail}</strong> with instructions
            to complete your account setup.
          </BodyText>

          <Box
            p={6}
            bg="blue.50"
            borderRadius="md"
            width="100%"
            maxW="600px"
            mt={4}
          >
            <Flex align="flex-start" gap={4}>
              <EmailIcon w={6} h={6} color="blue.500" mt={1} />
              <VStack align="start" spacing={3}>
                <BodyText size="medium" fontWeight="600">
                  Next Steps
                </BodyText>
                <BodyText size="small">
                  1. Check <strong>{userEmail}</strong> for a message from
                  Profit Assist
                </BodyText>
                <BodyText size="small">
                  2. Click the verification link in the email
                </BodyText>
                <BodyText size="small">
                  3. Complete your account setup with the provided instructions
                </BodyText>
              </VStack>
            </Flex>
          </Box>

          <Flex gap={4} mt={6} direction={{ base: 'column', md: 'row' }}>
            <Button
              variant="primary"
              onClick={() => navigate('/login')}
              style={{ minWidth: '150px' }}
            >
              Go to Login
            </Button>
          </Flex>

          <BodyText size="small" color="gray.500" mt={4}>
            Didn't receive an email?{' '}
            <Link href="/register" variant="primary">
              Try registering again
            </Link>{' '}
            or contact support.
          </BodyText>
        </VStack>
      </Container>
    </Box>
  );
};

export default RegistrationConfirmation;
